import React from "react";
import { Progress } from "reactstrap";
import { formatXp, getLevelGradient } from "./../../../helper/xpHelpers.js";

/**
 * XpBar — barra de progresso de XP com level atual e proximo.
 * Props:
 *  - totalXp, currentLevel: { level, name, requiredXp, color, icon }
 *  - nextLevel: { level, requiredXp } | null
 *  - xpToNextLevel: number
 *  - percentToNext: 0-100
 *  - compact: bool (modo widget)
 */
class XpBar extends React.Component {
  render() {
    var {
      totalXp = 0,
      currentLevel = { level: 1, name: 'Bronze I', icon: 'fas fa-medal' },
      nextLevel,
      xpToNextLevel = 0,
      percentToNext = 0,
      compact = false
    } = this.props;

    var gradient = getLevelGradient(currentLevel.level);

    return (
      <div className={compact ? 'p-2' : 'p-3'} style={{
        background: '#fff',
        borderRadius: '10px',
        border: '1px solid #eee',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
      }}>
        <div className="d-flex align-items-center mb-2">
          <div style={{
            width: compact ? '36px' : '48px',
            height: compact ? '36px' : '48px',
            background: gradient,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: compact ? '0.9rem' : '1.2rem',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            marginRight: '10px',
            flexShrink: 0
          }}>
            <i className={currentLevel.icon || 'fas fa-medal'} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="d-flex justify-content-between align-items-baseline">
              <strong style={{ fontSize: compact ? '0.85rem' : '1rem' }}>
                {currentLevel.name || ('Nível ' + currentLevel.level)}
              </strong>
              <small className="text-muted">
                {formatXp(totalXp)} XP
              </small>
            </div>
            {!compact && nextLevel && (
              <small className="text-muted">
                Falta <strong>{formatXp(xpToNextLevel)} XP</strong> pro {nextLevel.name || ('Nível ' + nextLevel.level)}
              </small>
            )}
            {!compact && !nextLevel && (
              <small className="text-success font-weight-bold">
                <i className="fas fa-crown mr-1" />Nível máximo!
              </small>
            )}
          </div>
        </div>
        <Progress
          value={percentToNext}
          style={{ height: '8px', backgroundColor: '#f0f0f0' }}
          barStyle={{ background: gradient }}
        />
      </div>
    );
  }
}

export default XpBar;
